import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import '../App.css';
import '../index.css';
import TrafficLogTableEntry from "./TrafficLogTableEntry";
import LogTableMarker from "./LogTableMarker";
import Titlebar from "../Titlebar";
import { apiUrl } from "../config";

const getItems = [
    {
        idx: '0',
        id: 'item-0000',
        type: 'marker',
        time: '00:00',
    },
    {
        idx: '1',
        id: 'item-0030',
        type: 'marker',
        time: '00:30',
    },
    {
        idx: '2',
        id: 'item-0100',
        type: 'marker',
        time: '01:00',
    },
    {
        idx: '3',
        id: 'item-0130',
        type: 'marker',
        time: '01:30',
    },
    {
        idx: '4',
        id: 'item-0200',
        type: 'marker',
        time: '02:00',
    },
    {
        idx: '5',
        id: 'item-0230',
        type: 'marker',
        time: '02:30',
    },
    {
        idx: '6',
        id: 'item-0300',
        type: 'marker',
        time: '03:00',
    },
    {
        idx: '7',
        id: 'item-0330',
        type: 'marker',
        time: '03:30',
    },
    {
        idx: '8',
        id: 'item-0400',
        type: 'marker',
        time: '04:00',
    },
    {
        idx: '9',
        id: 'item-0430',
        type: 'marker',
        time: '04:30',
    },
    {
        idx: '10',
        id: 'item-0500',
        type: 'marker',
        time: '05:00',
    },
    {
        idx: '11',
        id: 'item-0530',
        type: 'marker',
        time: '05:30',
    },
    {
        idx: '12',
        id: 'item-0600',
        type: 'marker',
        time: '06:00',
    },
    {
        idx: '13',
        id: 'item-0630',
        type: 'marker',
        time: '06:30',
    },
    {
        idx: '14',
        id: 'item-0700',
        type: 'marker',
        time: '07:00',
    },
    {
        idx: '15',
        id: 'item-0730',
        type: 'marker',
        time: '07:30',
    },
    {
        idx: '16',
        id: 'item-0800',
        type: 'marker',
        time: '08:00',
    },
    {
        idx: '17',
        id: 'item-0830',
        type: 'marker',
        time: '08:30',
    },
    {
        idx: '18',
        id: 'item-0900',
        type: 'marker',
        time: '09:00',
    },
    {
        idx: '19',
        id: 'item-0930',
        type: 'marker',
        time: '09:30',
    },
    {
        idx: '20',
        id: 'item-1000',
        type: 'marker',
        time: '10:00',
    },
    {  
        idx: '21',
        id: 'item-1030',
        type: 'marker',
        time: '10:30',
    },
    {
        idx: '22',
        id: 'item-1100',
        type: 'marker',
        time: '11:00',
    },
    {
        idx: '23',
        id: 'item-1130',
        type: 'marker',
        time: '11:30',
    },
    {
        idx: '24',
        id: 'item-1200',
        type: 'marker',
        time: '12:00',
    },
    {
        idx: '25',
        id: 'item-1230',
        type: 'marker',
        time: '12:30',
    },
    {
        idx: '26',
        id: 'item-1300',
        type: 'marker',
        time: '13:00',
    },
    {
        idx: '27',
        id: 'item-1330',
        type: 'marker',
        time: '13:30',
    },
    {
        idx: '28',
        id: 'item-1400',
        type: 'marker',
        time: '14:00',
    },
    {
        idx: '29',
        id: 'item-1430',
        type: 'marker',
        time: '14:30',
    },
    {
        idx: '30',
        id: 'item-1500',
        type: 'marker',
        time: '15:00',
    },
    {
        idx: '31',
        id: 'item-1530',
        type: 'marker',
        time: '15:30',
    },
    {
        idx: '32',
        id: 'item-1600',
        type: 'marker',
        time: '16:00',
    },
    {
        idx: '33',
        id: 'item-1630',
        type: 'marker',
        time: '16:30',
    },
    {
        idx: '34',
        id: 'item-1700',
        type: 'marker',
        time: '17:00',
    },
    {
        idx: '35',
        id: 'item-1730',
        type: 'marker',
        time: '17:30',
    },
    {
        idx: '36',
        id: 'item-1800',
        type: 'marker',
        time: '18:00',
    },
    {
        idx: '37',
        id: 'item-1830',
        type: 'marker',
        time: '18:30',
    },
    {
        idx: '38',
        id: 'item-1900',
        type: 'marker',
        time: '19:00',
    },
    {
        idx: '39',
        id: 'item-1930',
        type: 'marker',
        time: '19:30',
    },
    {
        idx: '40',
        id: 'item-2000',
        type: 'marker',
        time: '20:00',
    },
    {
        idx: '41',
        id: 'item-2030',
        type: 'marker',
        time: '20:30',
    },
    {
        idx: '42',
        id: 'item-2100',
        type: 'marker',
        time: '21:00',
    },
    {
        idx: '43',
        id: 'item-2130',
        type: 'marker',
        time: '21:30',
    },
    {
        idx: '44',
        id: 'item-2200',
        type: 'marker',
        time: '22:00',
    },
    {
        idx: '45',
        id: 'item-2230',
        type: 'marker',
        time: '22:30',
    },
    {
        idx: '46',
        id: 'item-2300',
        type: 'marker',
        time: '23:00',
    },
    {
        idx: '47',
        id: 'item-2330',
        type: 'marker',
        time: '23:30',
    },
  ];

// a little function to help us with reordering the result
const moveItem = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 1;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid,
  margin: `0 0 ${grid}px 0`,
  fontWeight: "bold", 
  borderRadius: "0.375rem",

  // change background colour if dragging
  color: isDragging ? "white" : "black",
  background: isDragging ? "lightgreen" : "white",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getMarkerStyle = () => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid,
    margin: `0 0 ${grid}px 0`,
    fontWeight: "bold", 
  
    // change background colour if dragging
    color: "grey",
  });

class TrafficLogTable extends Component {
    getDateOnlyValue(dateValue) {
        if (!dateValue) {
            return null;
        }

        if (typeof dateValue === 'string') {
            const dateMatch = dateValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (dateMatch) {
                const year = Number(dateMatch[1]);
                const month = Number(dateMatch[2]);
                const day = Number(dateMatch[3]);
                return new Date(year, month - 1, day);
            }
        }

        const parsedDate = new Date(dateValue);
        if (Number.isNaN(parsedDate.getTime())) {
            return null;
        }

        return new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
    }

    isCurrentOrPastRunDate() {
        const runDate = this.getDateOnlyValue(this.props.rundate);
        if (!runDate) {
            return false;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return runDate <= today;
    }

    isCurrentRunDate() {
        const runDate = this.getDateOnlyValue(this.props.rundate);
        if (!runDate) {
            return false;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return runDate.getTime() === today.getTime();
    }

    isPastRunDate() {
        const runDate = this.getDateOnlyValue(this.props.rundate);
        if (!runDate) {
            return false;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return runDate < today;
    }

    canGenerateLog() {
        if (this.isPastRunDate()) {
            return false;
        }

        if (this.props.hasPersistedLog) {
            return false;
        }

        const entryCount = this.getEntryItemsFromItems(this.state.items).length;
        return entryCount === 0;
    }

    isEditingLocked() {
        if (this.isPastRunDate()) {
            return true;
        }

        if (this.isCurrentRunDate() && this.props.hasPersistedLog) {
            return true;
        }

        return false;
    }

    getMinutesFromTimeValue(timeValue) {
        if (!timeValue || typeof timeValue !== 'string') {
            return Number.MAX_SAFE_INTEGER;
        }

        const parts = timeValue.split(':');
        if (parts.length < 2) {
            return Number.MAX_SAFE_INTEGER;
        }

        const hours = Number(parts[0]);
        const minutes = Number(parts[1]);
        if (Number.isNaN(hours) || Number.isNaN(minutes)) {
            return Number.MAX_SAFE_INTEGER;
        }

        return (hours * 60) + minutes;
    }

    getSortMinutesForItem(item) {
        if (!item) {
            return Number.MAX_SAFE_INTEGER;
        }

        if (item.type === 'marker') {
            return this.getMinutesFromTimeValue(item.time);
        }

        if (item.time_of_day) {
            return this.getMinutesFromTimeValue(item.time_of_day);
        }

        return this.getMinutesFromTimeValue(item.time);
    }

    buildEntryIdFromTime(timeValue) {
        if (!timeValue || typeof timeValue !== 'string') {
            return undefined;
        }

        const parts = timeValue.split(':');
        if (parts.length < 2) {
            return undefined;
        }

        const hour = String(parts[0]).padStart(2, '0');
        const minute = String(parts[1]).padStart(2, '0');
        return `item-${hour}${minute}`;
    }

    buildUniqueEntryId(baseId, items, destinationIndex) {
        if (!baseId) {
            return undefined;
        }

        const usedIds = new Set(
            (items || [])
                .filter((item, index) => index !== destinationIndex)
                .map((item) => item?.id)
                .filter(Boolean)
        );

        if (!usedIds.has(baseId)) {
            return baseId;
        }

        let suffix = 1;
        let candidateId = `${baseId}-${suffix}`;
        while (usedIds.has(candidateId)) {
            suffix += 1;
            candidateId = `${baseId}-${suffix}`;
        }

        return candidateId;
    }

    getEntryItemsFromItems(items) {
        return (items || []).filter((item) => item.type !== 'marker');
    }

    buildItemsFromEntries(entries) {
        let items = [...getItems];

        if (Array.isArray(entries)) {
            for (let i = 0; i < entries.length; i++) {
                const logEntry = { ...entries[i] };
                logEntry.idx = (i + 48).toString();
                items.push(logEntry);
            }
        }

        const indexedItems = items.map((item, index) => ({ item, index }));
        indexedItems.sort((a, b) => {
            const aMinutes = this.getSortMinutesForItem(a.item);
            const bMinutes = this.getSortMinutesForItem(b.item);

            if (aMinutes !== bMinutes) {
                return aMinutes - bMinutes;
            }

            return a.index - b.index;
        });

        return indexedItems.map(({ item }) => item);
    }

    extractEntriesFromGenerateResponse(data) {
        if (!data) {
            return [];
        }

        if (Array.isArray(data)) {
            return data;
        }

        if (Array.isArray(data.entries)) {
            return data.entries;
        }

        if (data.log_data) {
            try {
                const parsedLogData = typeof data.log_data === 'string'
                    ? JSON.parse(data.log_data)
                    : data.log_data;

                if (Array.isArray(parsedLogData)) {
                    return parsedLogData;
                }

                if (parsedLogData && Array.isArray(parsedLogData.entries)) {
                    return parsedLogData.entries;
                }
            } catch (error) {
                console.error('Error parsing generated log_data:', error);
            }
        }

        return [];
    }

  constructor(props) {
    super(props);

    const items = this.buildItemsFromEntries(props.logdata);

    this.state = {
            items: items,
            isGeneratingLog: false
    };  
 
    this.onDragEnd = this.onDragEnd.bind(this);
        this.handleGenerateLog = this.handleGenerateLog.bind(this);
  }

    async handleGenerateLog() {
        if (this.state.isGeneratingLog || !this.canGenerateLog()) {
            return;
        }

        this.setState({ isGeneratingLog: true });
        try {
            const dateValue = this.props.rundate || new Date().toISOString().split('T')[0];
            const response = await fetch(apiUrl(`/runlog/generate?date=${encodeURIComponent(dateValue)}`));
            if (!response.ok) {
                console.error('Generate log failed:', response.status, response.statusText);
                return;
            }

            const responseData = await response.json();
            const generatedEntries = this.extractEntriesFromGenerateResponse(responseData);
            const items = this.buildItemsFromEntries(generatedEntries);
            this.setState({ items });

            if (typeof this.props.onLogChange === 'function') {
                this.props.onLogChange(generatedEntries);
            }

            if (generatedEntries.length > 0 && typeof this.props.onLogGenerated === 'function') {
                this.props.onLogGenerated(generatedEntries);
            }
        } catch (error) {
            console.error('Error generating log:', error);
        } finally {
            this.setState({ isGeneratingLog: false });
        }
    }

  // Add componentDidUpdate to handle prop changes
  componentDidUpdate(prevProps) {
    // Check if logdata prop has changed
    if (prevProps.logdata !== this.props.logdata) {
            const items = this.buildItemsFromEntries(this.props.logdata);
      this.setState({ items: items });

            if (typeof this.props.onLogChange === 'function') {
                this.props.onLogChange(Array.isArray(this.props.logdata) ? this.props.logdata : []);
            }
    }
  }

  onDragEnd(result) {
        if (this.isEditingLocked()) {
            return;
        }

    // dropped outside the list
    if (!result.destination) {
      return;
    }

    let draggedItem = this.state.items[result.source.index];
    if (draggedItem.type === 'marker') {
      return;
    }

    // return if the spot is dragged above the 00 marker 
    if (result.destination.index === 0) {
        return;
    }   

    // We need to reorder the list and regenerate the time marker for the placed spot. 
    const items = moveItem(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    // seek the earliest marker above the placed spot
    let markerIndex = 0;
    for (let i = result.destination.index - 1; i >= 0; i--) {
        if (items[i].type === 'marker') {
            markerIndex = i;
            break;
        }
    }
    // update the time marker for the placed spot
    let time = items[markerIndex].time;
    // console.log(time);
    // detect if the time is on the hour or half hour
    let timeArray = time.split(':');
    let minutes = parseInt(timeArray[1]);
    
    if (minutes === 0) {
        time = timeArray[0] + ':13:00';
    } else {
        time = (parseInt(timeArray[0])).toString().padStart(2, '0') + ':43:00';
    }
    items[result.destination.index].time_of_day = time;
        const updatedId = this.buildEntryIdFromTime(time);
        const uniqueUpdatedId = this.buildUniqueEntryId(updatedId, items, result.destination.index);
        if (uniqueUpdatedId) {
            items[result.destination.index].id = uniqueUpdatedId;
        }
    
    this.setState({
      items
    });

        if (typeof this.props.onLogReordered === 'function') {
            this.props.onLogReordered();
        }

        if (typeof this.props.onLogChange === 'function') {
            this.props.onLogChange(this.getEntryItemsFromItems(items));
        }
  }

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
render() {
    const isEditingLocked = this.isEditingLocked();
    const hasNoLogEntries = this.getEntryItemsFromItems(this.state.items).length === 0;
    const shouldShowGenerateButton = hasNoLogEntries && !this.props.hasPersistedLog;
    const canGenerateLog = this.canGenerateLog();

  return (
  <div className="lg:pl-72 sm:ml-0 px-0 sm:px-0">
      {
      this.props.showtitlebar === true && 
      <Titlebar title="Traffic Logs" rundate={this.props.rundate}/>
      }

    <div className="mx-4 my-4 lg:px-4 rounded-md">
    <DragDropContext onDragEnd={this.onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div 
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            
                        {shouldShowGenerateButton ? (
                            <div className="py-6 text-center">
                                <button
                                    type="button"
                                    onClick={this.handleGenerateLog}
                                    disabled={this.state.isGeneratingLog || !canGenerateLog}
                                    className={`rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm ${(this.state.isGeneratingLog || !canGenerateLog) ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500'}`}
                                >
                                    {this.state.isGeneratingLog ? 'Generating...' : 'Generate Log'}
                                </button>
                            </div>
                        ) : (
                            this.state.items.map((item, index) => (
                                <Draggable key={item.idx} draggableId={item.idx} index={index} isDragDisabled={isEditingLocked || item.type === 'marker'}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                            )}
                                        >
                                        {(
                                        item.type === 'marker' ?
                                        <LogTableMarker index={index} marker={item}
                                        style={getMarkerStyle()}
                                        />
                                        :
                                            <TrafficLogTableEntry                       
                                            innerRef={provided.innerRef}
                                            draggableProps={provided.draggableProps}
                                            dragHandleProps={isEditingLocked ? undefined : provided.dragHandleProps}
                                            isDragging={snapshot.isDragging}
                                            isEditable={!isEditingLocked}
                                            logentry={item} 
                                            index={index} 
                                            />
                                        )}
                                        </div>
                                    )}
                                </Draggable>
                            ))
                        )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
    </div>
    </div>
  );
  }
}

export default TrafficLogTable;